export enum ORIENTATION_ANGLE {
  PORTRAIT = 'PORTRAIT',
  LANDSCAPE = 'LANDSCAPE',
}

export const PROJECT_CHILD_ITEM_STATUS: {
  [key: string]: { key: string; label: string; color?: string };
} = {
  INACTIVE: {
    key: 'INACTIVE',
    label: 'properties.resident-status.inactive',
    color: '#999',
  },
  NOT_SOLD_YET: {
    key: 'NOT_SOLD_YET',
    label: 'properties.resident-status.not-sold-yet',
    color: '#999',
  },
  ON_SALE: { key: 'ON_SALE', label: 'properties.resident-status.on-sale', color: '#27ae60' },
  FOR_RENT: { key: 'FOR_RENT', label: 'properties.resident-status.for-rent', color: '#27ae60' },
  RESERVED: {
    key: 'RESERVED',
    label: 'properties.resident-status.reserved',
    color: '#f39c12',
  },
  DEPOSITED: {
    key: 'DEPOSITED',
    label: 'properties.resident-status.deposited',
    color: '#e67e22',
  },
  SOLD: { key: 'SOLD', label: 'properties.resident-status.sold', color: '#c0392b' },
  RENTED: { key: 'RENTED', label: 'properties.resident-status.rented', color: '#c0392b' },
  OTHER: { key: 'OTHER', label: 'properties.resident-status.other', color: '#8e44ad' },
};

export const PROJECT_CHILD_ITEM_RESIDENCE_TYPE = {
  VILLA: { key: 'VILLA', label: 'properties.resident-type.villa' },
  APARTMENT: { key: 'APARTMENT', label: 'properties.resident-type.apartment' },
  FLAT: { key: 'FLAT', label: 'properties.residence-type.flat' },
  STUDIO: { key: 'STUDIO', label: 'properties.residence-type.studio' },
  PENTHOUSE: { key: 'PENTHOUSE', label: 'properties.residence-type.penthouse' },
  CONDOMINIUM: { key: 'CONDOMINIUM', label: 'properties.residence-type.condominium' },
  CONDOTEL: { key: 'CONDOTEL', label: 'properties.residence-type.condotel' },
  DUPLEX: { key: 'DUPLEX', label: 'properties.residence-type.duplex' },
  BUNGALOW: { key: 'BUNGALOW', label: 'properties.residence-type.bungalow' },
  TWIN: { key: 'TWIN', label: 'properties.residence-type.twin' },
  SEMI_DETACHED: { key: 'SEMI_DETACHED', label: 'properties.residence-type.semi-detached' },
  DETACHED: { key: 'DETACHED', label: 'properties.residence-type.detached' },
  COASTAL: { key: 'COASTAL', label: 'properties.residence-type.coastal' },
  MANSION: { key: 'MANSION', label: 'properties.residence-type.mansion' },
  TOWNHOUSE: { key: 'TOWNHOUSE', label: 'properties.residence-type.townhouse' },
  GARDEN_TOWNHOUSE: {
    key: 'GARDEN_TOWNHOUSE',
    label: 'properties.residence-type.garden-townhouse',
  },
  TERRACED_HOUSE: { key: 'TERRACED_HOUSE', label: 'properties.residence-type.terraced-house' },
  SHOP_HOUSE: { key: 'SHOP_HOUSE', label: 'properties.residence-type.shop-house' },
};

export const DIRECTION_TYPE = {
  EAST: { key: 'EAST', label: 'common.direction-type.east' },
  WEST: { key: 'WEST', label: 'common.direction-type.west' },
  SOUTH: { key: 'SOUTH', label: 'common.direction-type.south' },
  NORTH: { key: 'NORTH', label: 'common.direction-type.north' },
  SOUTHEAST: { key: 'SOUTHEAST', label: 'common.direction-type.south-east' },
  SOUTHWEST: { key: 'SOUTHWEST', label: 'common.direction-type.south-west' },
  NORTHEAST: { key: 'NORTHEAST', label: 'common.direction-type.north-east' },
  NORTHWEST: { key: 'NORTHWEST', label: 'common.direction-type.north-west' },
};

export const PROJECT_ITEM_TYPE = {
  BUILDING: { key: 'BUILDING', label: 'common.project-item-type.building' },
  BLOCK: { key: 'BLOCK', label: 'common.project-item-type.block' },
};

export const FLOOR = {
  SHORT: { key: 'FLOOR_SHORT', label: 'common.floor.short' },
  FULL: { key: 'FLOOR_FULL', label: 'common.floor.full' },
};

export const POSITION_TYPE = {
  SIDE: { key: 'SIDE', label: 'common.position-type.side' },
  MIDDLE: { key: 'MIDDLE', label: 'common.position-type.middle' },
};
export const STATUS_SESSION = {
  OPEN: { key: 'OPEN', label: 'session.status.open', color: '#27ae60' },
  CLOSE: { key: 'CLOSE', label: 'session.status.close', color: '#e67e22' },
};

export enum PROPERTIES_STATUS {
  NOT_SOLD_YET = 'NOT_SOLD_YET',
  SOLD = 'SOLD',
  RENTED = 'RENTED',
  ON_SALE = 'ON_SALE',
  INACTIVE = 'INACTIVE',
  RESERVED = 'RESERVED',
  DEPOSITED = 'DEPOSITED',
  FOR_RENT = 'FOR_RENT',
  OTHER = 'OTHER',
}

export enum STATUS_CHP {
  FOR_RENT = 'FOR_RENT',
  ON_SALE = 'ON_SALE',
}

export enum STATUS_CLOSE_CHP {
  SOLD = 'SOLD',
  RENTED = 'RENTED',
  INACTIVE = 'INACTIVE',
  NOT_SOLD_YET = 'NOT_SOLD_YET',
}

export enum SELLERS_STATUS {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  DECLINE = 'DECLINE',
}

export const CURRENCY = {
  VND: { key: 'VND', label: 'VND', apiKey: 'vnd' },
  USD: { key: 'USD', label: 'USD', apiKey: 'usd' },
  JPY: { key: 'JPY', label: 'JPY', apiKey: 'jpy' },
  CNY: { key: 'CNY', label: 'CNY', apiKey: 'cny' },
  KRW: { key: 'KRW', label: 'KRW', apiKey: 'krw' },
};

export const CREATE_SESSION_STEP = {
  SELECT_CHP: { key: 'SELECT_CHP', title: 'session.selected-chp', index: 0 },
  CONFIG_PRICE: { key: 'CONFIG_PRICE', title: 'session.config-price', index: 1 },
  CONFIG_FEATURE: { key: 'CONFIG_FEATURE', title: 'session.config-features', index: 2 },
  CONFIG_CONTRACT: { key: 'CONFIG_CONTRACT', title: 'session.config-contracts.title', index: 3 },
  SELECT_AGENT: { key: 'SELECT_AGENT', title: 'session.selected-agent', index: 4 },
  CONFIRM: { key: 'SELECT_CHP', title: 'session.confirm', index: 5 },
};

export enum TERM_OF_CONTRACT_FIELD_TYPE {
  NUMBER = 'NUMBER',
  CHECK_BOX = 'CHECK_BOX',
  DATE_TIME = 'DATE_TIME',
  FREE_TEXT = 'FREE_TEXT',
}

export const COLOR = {
  ORANGE: '#f50',
  BLUE: '#108ee9',
};

export enum STATUS_STEP {
  WAIT = 'wait',
  PROCESS = 'process',
  FINISH = 'finish',
  ERROR = 'error',
}
